import { render } from "./vgoinmonadadd.vue?vue&type=template&id=a12923d6&scoped=true"
import script from "./vgoinmonadadd.vue?vue&type=script&lang=js"
export * from "./vgoinmonadadd.vue?vue&type=script&lang=js"

import "./vgoinmonadadd.vue?vue&type=style&index=0&id=a12923d6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12923d6"]])

export default __exports__